/**=========================================================
 * Module: app-zip.js
 * Messages list
 =========================================================*/

 App.directive('appZip', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/zip.html',
        restrict: 'E',
        replace: true,
        controller: 'ZipController',
        scope: { 
            files: '=files',
            type: '@type',
            field: '@field',
            entity: '@entity',
            parentid: '@parentid',
            zipFilename: '@filename',
            extension: '@extension',
            bucket: '@bucket',
            action: '@action',
            jobId: '@jobId',
            noAutoDownload: '@noAutoDownload'
          }
    };
  
  });